module.exports = __webpack_public_path__ + "static/media/desk-logo.cb409ae8.svg";